import React from "react";

const SvgFont = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      style={style}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.9334 15.8667H3V18H17.9334V15.8667Z" fill="#BEBEBE" />
      <path
        d="M7.79998 11.3866H13.1333L14.0933 13.7333H16.3333L11.2666 2H9.66663L4.59998 13.7333H6.83998L7.79998 11.3866ZM10.4666 4.112L12.4613 9.46665H8.47193L10.4666 4.112Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgFont;
